import React, {Component, Fragment} from "react"
import {Link, withRouter} from "react-router-dom"
import shop from "shop/shop"
import {observer} from "mobx-react"
import {Button, Icon, Popup, Modal} from "semantic-ui-react"
import {Form, FormField, FormInput} from "elemental-react16"

import NewCustomerPage from "pages/NewCustomerPage"
import ResetPasswordPage from "pages/ResetPasswordPage"
import NewCustomerContactPage from "pages/NewCustomerContactPage"

@withRouter
@observer
export default class LoginLinkHover extends Component {

	constructor() {
		super()
		this.state = {
			sum: 0,
            showCalc:       false,
			hasFocus:       false,
			user:           "",
			password:       "",
			login:          true,
			register:       false,
			resetPW:        false,
			customerRegister: false,
		}
	}

	handleLogin = (e) => {
		e.preventDefault()
		const { history } = this.props
		shop.loginOrfix({ user: this.state.user, password: this.state.password })
			.catch((err) => {
				console.error(err)
				shop.toast(translate("Fehler bei der Anmeldung"), "error")
				return false
			})
			.then(async session => {
				if (!session) return
				if (shop.orderlist && shop.orderlist.lists && shop.orderlist.lists.Standard
					&& shop.orderlist.lists.Standard.title === "Standard"
					&& !shop.store.orderlist.currentList) {
					shop.store.orderlist.setCurrentList(shop.orderlist.lists.Standard)
				}
				shop.loadCategories()
				await shop.cart.hydrateLogin()
				shop.toast(`${translate("Willkommen")} ${session.value.title ? session.value.title : ""}`)
				this.setState({ showCalc: false })
				const handId = session.handId
				if (handId && handId !== "") {
					history.push("/login/accounts/")
					return
				}
				if (shop.config.bShop_Theme && shop.config.bShop_Theme.bshop_frontend_theme === "QuickOrderPlus") {
					history.push("/quickorder")
				} else {
					const redirectTo = shop.locationAfterLogin
					if (redirectTo
						&& redirectTo !== "/login/" && redirectTo !== "/login"
						&& redirectTo !== "/home/login/" && redirectTo !== "/home/login"
					) {
						history.push(redirectTo)
					} else {
						history.push("/home")
					}
				}
			})
	}

	handleTabButtons = (name) => {
		if (name === "login") {
			this.setState({ login: true, register: false })
		} else if (name === "register") {
			this.setState({ login: false, register: true })
		}
	}

	renderInlineLoginPanel() {
		const { login, register, resetPW, customerRegister } = this.state
		return (
			<div
			style={{ width: "100%", padding: "16px 20px", borderRadius: "20px", boxSizing: "border-box" }}
			className="bg-white shadow-4"
			onFocus={() => {
				if (this.leaveTimeout) { clearTimeout(this.leaveTimeout); this.leaveTimeout = null }
				this.setState({ hasFocus: true })
			}}
			onBlur={(e) => {
				if (!e.currentTarget.contains(e.relatedTarget)) {
					this.setState({ hasFocus: false })
					this.leaveTimeout = setTimeout(() => {
						this.setState({ showCalc: false })
					}, 200)
				}
			}}
		>

				{/* Tab-Switcher */}
				<div className="flex flex-row justify-center pb3" style={{ borderBottom: "2px solid rgb(201,201,201)" }}>
					<div style={{ borderBottom: login ? "2px solid #a2cf66" : "none", marginBottom: "-2px" }}>
						<button
							style={{ minWidth: "100px", border: "none", background: "transparent", cursor: "pointer" }}
							onClick={() => this.handleTabButtons("login")}
						>
							<p className="pa2 fw6 f5">{translate("Anmelden")}</p>
						</button>
					</div>
					<div style={{ borderBottom: register ? "2px solid #a2cf66" : "none", marginBottom: "-2px" }}>
						<button
							style={{ minWidth: "100px", border: "none", background: "transparent", cursor: "pointer" }}
							onClick={() => this.handleTabButtons("register")}
						>
							<p className="pa2 fw6 f5">{translate("Registrieren")}</p>
						</button>
					</div>
				</div>

				{/* Registrieren-Tab */}
				{register && <Fragment>
					<div className="pt3">
						<NewCustomerPage />
					</div>
					<div className="flex flex-row justify-center pt2">
						<span className="pr1 fw6 f6">{translate("Sie haben bereits ein Konto?")}</span>
						<Link style={{ color: "#a2cf66" }} className="fw6 f6" onClick={() => this.handleTabButtons("login")}>
							{translate("Hier anmelden")}
						</Link>
					</div>
				</Fragment>}

				{/* Anmelden-Tab */}
				{login && <Fragment>
					<div className="pt3 pb2">
						<Form onSubmit={this.handleLogin}>
							<FormField
								label={translate("Benutzer")}
								title={translate("Anmeldung mit E-Mail-Adresse oder Kunden-Nr.")}
								htmlFor="hover-input-user"
							>
								<FormInput
									style={{ width: "100%", borderRadius: "35px", backgroundColor: "#ffffff" }}
									value={this.state.user}
									onChange={(e) => this.setState({ user: e.target.value })}
									type="text"
									placeholder={translate("E-Mail-Adresse / Kunden-Nr.")}
									name="hover-input-user"
								/>
							</FormField>
							<FormField label={translate("Passwort")} htmlFor="hover-input-password">
								<FormInput
									value={this.state.password}
									onChange={(e) => this.setState({ password: e.target.value })}
									type="password"
									placeholder={translate("Passwort")}
									name="hover-input-password"
								/>
							</FormField>
							<div className="tc pt2 pb2">
								<Button
									style={{ width: "100%", borderRadius: "35px", height: "45px" }}
									primary
									submit
								>
									{translate("Anmelden")}
								</Button>
								<Link
									className="db mt2 fw6 f6"
									style={{ color: "#a2cf66" }}
									onClick={() => this.setState({ resetPW: !resetPW })}
								>
									{translate("Passwort vergessen")}?
								</Link>
								{resetPW && <div className="pb3 pt3"><ResetPasswordPage /></div>}
							</div>
						</Form>
					</div>
					<div className="flex flex-row justify-center pt2" style={{ borderTop: "2px solid rgb(201,201,201)" }}>
						<span className="pr1 fw6 f6">{translate("loginpage.noaccounthint")}</span>
						<Link style={{ color: "#a2cf66" }} className="fw6 f6" onClick={() => this.handleTabButtons("register")}>
							{translate("loginpage.registerlink")}
						</Link>
					</div>
				</Fragment>}

				{/* Zugang anfordern */}
				<div className="flex flex-row justify-center pt2">
					<span className="pr1 fw6 f6">{translate("loginpage.alreadycustomer")}</span>
					<Link style={{ color: "#a2cf66" }} className="fw6 f6" onClick={() => this.setState({ customerRegister: true })}>
						{translate("loginpage.requestlogin")}
					</Link>
				</div>
				<Modal style={{ borderRadius: 20 }} className="ModalLoginPage"
					size="small"
					open={customerRegister}
					onClose={() => this.setState({ customerRegister: false })}
				>
					<Modal.Header>
						<div className="flex flex-row justify-between items-center">
							<div>{translate("Zugang anfordern")}</div>
							<Button basic circular onClick={() => this.setState({ customerRegister: false })} icon="times" />
						</div>
					</Modal.Header>
					<Modal.Content style={{ overflowX: "hidden" }}>
						<div style={{ maxWidth: "100%" }}>
							<NewCustomerContactPage closeModal={true} onCloseModal={() => this.setState({ customerRegister: false })} />
						</div>
					</Modal.Content>
				</Modal>

			</div>
		)
	}

	render() {
        const { located } = this.props
        const loginOnHover = shop.config && shop.config.plugin && shop.config.plugin.loginOnHover

        if (located === "HeaderMenu") {
            return (
                <div className="CartButton relative">
                    <Button
                        style={{ width: "60px", height: "40px", borderRadius: "20px", backgroundColor: "transparent" }}
                        primary
                        id="loginLinkHover"
                        onMouseEnter={() => this.setState({ showCalc: true })}
                        onMouseLeave={() => {
                            this.leaveTimeout = setTimeout(() => {
                                if (!this.state.hasFocus) this.setState({ showCalc: false })
                            }, 100)
                        }}
                        onMouseOver={() => {
                            if (this.leaveTimeout) {
                                clearTimeout(this.leaveTimeout)
                                this.leaveTimeout = null
                            }
                        }}
                    >
                        <p style={{ color: "#346E5B", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", height: "100%" }}>
                            <Popup trigger={
                                <React.Fragment>
                                    <p className="f2 pt1">
                                        <Icon name="user " style={{ color: "#646363ff" }} />
                                    </p>
                                </React.Fragment>
                            }>
                            </Popup>
                        </p>
                    </Button>
                    <div>
                        {this.state.showCalc && (
                            <div
                                onMouseEnter={() => {
                                    if (this.leaveTimeout) {
                                        clearTimeout(this.leaveTimeout)
                                        this.leaveTimeout = null
                                    }
                                    this.setState({ showCalc: true })
                                }}
                                onMouseLeave={() => {
                                    this.leaveTimeout = setTimeout(() => {
                                        if (!this.state.hasFocus) this.setState({ showCalc: false })
                                    }, 100)
                                }}
                                style={loginOnHover
                                    ? { padding: 0, width: "432px", maxWidth: "calc(100vw - 16px)", right: 0, alignContent: "center", zIndex: "99", background: "transparent", animation: "fadeIn 0.5s" }
                                    : { padding: 0, width: "10px", alignContent: "center", zIndex: "99", background: "transparent", animation: "fadeIn 0.5s" }}
                                className="absolute bg-white z-99 variantsContainer"
                            >
                                {loginOnHover ? (
                                    <div style={{ marginTop: "15px" }}>
                                        {this.renderInlineLoginPanel()}
                                    </div>
                                ) : (
                                    <div style={{ alignContent: "center", width: "350px", zIndex: "99", marginLeft: "-150px", borderRadius: "20px", marginTop: "15px" }} className="justify-between bg-white pa3 VariantsPullDownCart shadow-4">
                                        <div style={{ backgroundColor: "#ffffffff" }}>
                                            <table className="pb3">
                                                <tbody>
                                                    <tr>
                                                        <td className="tc pa3 bb b--black-10">
                                                            <p className="tl fw5">{translate("Sie sind bereits Kunde?")}</p>
                                                            <Button
                                                                style={{ minWidth: "280px", height: "45px", borderRadius: "35px", margin: 0, display: "flex", alignItems: "center", justifyContent: "center" }}
                                                                as={Link}
                                                                to={`/login/?referrer=${document.location.pathname}?login`}
                                                                primary
                                                            >
                                                                <p className="f5 fw5"><Icon name={"white power off"} />{translate("Bestandskunden anmelden")}</p>
                                                            </Button>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="tc pa3">
                                                            <p className="tl fw5">{translate("Sie sind Neukunde?")}</p>
                                                            <Button
                                                                style={{ minWidth: "280px", height: "45px", borderRadius: "35px", margin: 0, display: "flex", alignItems: "center", justifyContent: "center" }}
                                                                as={Link}
                                                                to={`/login/?referrer=${document.location.pathname}?register`}
                                                                primary
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                <p className="f5 fw5"><Icon name={"white file text"} />{translate("Neukundenanmeldung")}</p>
                                                            </Button>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            )
        }

        if (located === "ProductPage") {
            return (
                <div className="bg-white">
                    <div className="justify-between bg-white">
                    </div>
                </div>
            )
        }

        return null
	}
}



// WEBPACK FOOTER //
// ./src/theme/lucht-test/components/LoginLinkHover.js